<script>
import { Sprite, Container } from 'pixi.js'
import SceneMixin from '@/mixins/Scene'

export default {
  name: 'Scene14',
  mixins: [ SceneMixin ],
  beforeDestroy() {
    console.log('beforeDestroy');
    _.each(this.$sprites, (sp, index)=>{
      if(this.$els[index]) this.$els[index]['container'].removeChild(sp)
    })
    this.$container.removeChild(this.$scene)
  },

  created() {

    const sprites = {}
    this.$sprites = sprites

    this.$scene = new Container 
    this.$scene.interactiveChildren = false
    
    this.$container.addChild(this.$scene)
    this.$parent.$scene14 = this.$scene

    const container = new Container()
    this.setCenterContainer(container)   
    this.$scene.addChild(container)

    const bkg_container = new Container()
    const front_container = new Container()

    container.addChild(bkg_container)
    container.addChild(front_container)

    bkg_container.position.y = -0
    bkg_container.scale.set(1, 1)

    const tl = new TimelineMax()
    const sub1 = new TimelineMax()
    const sub2 = new TimelineMax()
    const sub3 = new TimelineMax()

    // ******************************************************** //
    // ******************************************************** //

    const els = {

      'bg': { container: bkg_container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 0.5 }},
      'grey3': { container: bkg_container, alpha: 1, position: { x: 0, y: 588, width: 1536, height: 2160 }},
      'grey2': { container: bkg_container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 0.5 }},
      'grey1': { container: bkg_container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 0.5 }},
      'hall': { container: bkg_container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 0.5 }}, 
      'board6': { container: front_container, alpha: 0, position: { x: 20, y: 556, width: 1536, height: 2160 }, scale: this.$root.$scale*0.2 },
      'board5': { container: front_container, alpha: 0, position: { x: 21, y: 530, width: 1536, height: 2160 }, scale: this.$root.$scale*0.25 },
      'board4': { container: front_container, alpha: 0, position: { x: 20, y: 510, width: 1536, height: 2160 }, scale: this.$root.$scale*0.30 },
      'board1': { container: front_container, alpha: 0, position: { x: 20, y: 480, width: 1536, height: 2160 }, scale: this.$root.$scale*0.35 }, 
      'board2': { container: front_container, alpha: 0, position: { x: 15, y: 400, width: 1536, height: 2160 }, scale: this.$root.$scale*.86 }, 
      'board3': { container: front_container, alpha: 0, position: { x: 20, y: 300, width: 1536, height: 2160 }, scale: this.$root.$scale*0.75 },
    }

    _.each(els, (el, name)=>{
      const _name = (el.ref) ? el.ref : name
      const sprite = new Sprite.from(this.$resources[_name].texture) 
            sprite.scale.set(this.$root.$scale)
            sprite.x -= this.$canvas_width/2
            sprite.y -= this.$canvas_height/2
            sprite.alpha = el.alpha
      el.container.addChild(sprite)
      sprites[name] = sprite
      this.applySettings(sprite, el)
    })

    this.$els = els

    // ******************************************************** //
    // ******************************************************** //

    const alphaFilter = new PIXI.filters.AlphaFilter(0.0)
    container.filters = [ alphaFilter ]

    const coef = .14
    const elements = [sprites['grey1'], sprites['grey2'], sprites['grey3']]
    
    sub1
      .to(alphaFilter, 1, { alpha: 1, ease: Linear.easeNone, onComplete: ()=>{ container.filters = null } })
      .add([   
        TweenMax.staggerFrom(elements, 2, { pixi:{  alpha: 0, y: '-=10' }, ease: Linear.easeNone }, 1),
        TweenMax.to(bkg_container, 7, { pixi:{ scale: 1.1 }, ease: Linear.easeNone }),
      ])
      .add([
        TweenMax.from(sprites['hall'], 2, { pixi:{  alpha: 0 }, ease: Linear.easeNone }),
        TweenMax.to(bkg_container, 30, { pixi:{ scale: 2.5, y: -700, x: -25 }, ease: Linear.easeNone }),
        TweenMax.to(front_container, 30, { pixi:{ scale: 3, y: -850, x: -25 }, ease: Linear.easeNone }),
      ])
      .add([
        TweenMax.to(bkg_container, 14, { pixi:{ scale: 5, y: -1400, x: -50 }, ease: Linear.easeNone }),
        TweenMax.to(front_container, 14, { pixi:{ scale: 6, y: -1700, x: -50 }, ease: Linear.easeNone }),
      ])
      // .to(sprites['hall'], 1, { pixi:{  alpha: 0 }, ease: Linear.easeNone })
      // .to(sprites['grey3'], 1, { pixi:{  alpha: 0 }, ease: Linear.easeNone })
  
    const x = 300
    const y = 150
    const timeBoard = 25*coef

    sub2
      .to(sprites.board3, 0.1, { pixi:{ alpha: 1 }})
      .from(sprites.board3, 2.5, { pixi:{ x: x*1.8 }, ease: Cubic.easeOut })
      .add([
        TweenMax.to(sprites.board3, 1, { pixi:{ y: -y*4 }, ease: Cubic.easeIn, delay: 1.5 }),
        TweenMax.to(sprites.board2, 0.1, { pixi:{ alpha: 1, scale: this.$root.$scale*.1, y: '+=0' } }),
        TweenMax.to(sprites.board2, 6.5, { pixi:{ scale: this.$root.$scale*.86, y: '-=18' }, ease: Cubic.easeOut, delay: 1.5 })
      ])

    const sub21 = new TimelineMax()
          .to(sprites.board2, 14, { pixi:{ y: '+=80', scale: this.$root.$scale*.54 }, ease: Cubic.easeNone, overwrite: false })
          // .to(sprites.board2, 6, { pixi:{ y: '+=20'}, ease: Cubic.easeNone, overwrite: false })

    sub3
      .add([
        TweenMax.to(sprites.board2, 1.5, { pixi:{ x: x }, ease: Cubic.easeIn }),
        TweenMax.to(sprites.board2, 1, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: 1 }),

        TweenMax.to(sprites.board1, 0.1, { pixi:{ alpha: 1, scale: this.$root.$scale*.1, y: '+=50' } }),
        TweenMax.to(sprites.board1, 4.5, { pixi:{ scale: this.$root.$scale*.3 }, ease: Linear.easeNone, delay: .25 })
      ])
      .add([ 
        TweenMax.to(sprites.board1, 1.5, { pixi:{ y: -y }, ease: Cubic.easeIn }),
        TweenMax.to(sprites.board1, 1, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: .25 }),
        TweenMax.to(sprites.board4, 0.1, { pixi:{ alpha: 1, scale: this.$root.$scale*.1, y: '+=35' } }),
        TweenMax.to(sprites.board4, 4, { pixi:{ scale: this.$root.$scale*.25, y: '-=10', x: 8 }, ease: Linear.easeNone, delay: .25 })
      ])
      .add([
        TweenMax.to(sprites.board5, 0.1, { pixi:{ alpha: 1, scale: this.$root.$scale*.1, y: '+=20' } }),
        TweenMax.to(sprites.board5, 4, { pixi:{ scale: this.$root.$scale*.21, y: '-=5', x: 8 }, ease: Linear.easeNone, delay: .25 }),
        TweenMax.to(sprites.board4, 1.5, { pixi:{ x: -x }, ease: Cubic.easeIn }),
        TweenMax.to(sprites.board4, 1, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: .25 }),
      ])
      .add([
        TweenMax.to(sprites.board6, 0.1, { pixi:{ alpha: 1, scale: this.$root.$scale*.15, y: '+=10' } }),
        TweenMax.to(sprites.board6, 4, { pixi:{ scale: this.$root.$scale*.2, y: '-=5', x: 9 }, ease: Linear.easeNone, delay: .25 }), 
        TweenMax.to(sprites.board5, 1.5, { pixi:{ x: x }, ease: Cubic.easeIn }),
        TweenMax.to(sprites.board5, 1, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: .25 }),
      ])
      .add([
        TweenMax.to(sprites.board6, 1.25, { pixi:{ alpha: 0 }, ease: Linear.easeNone }),
      ])
 
    this.$tl.add(sub1, 0)
    this.$tl.add(sub2, 11)
    this.$tl.add(sub21, 24)
    this.$tl.add(sub3, 39)

  },
  mounted() {

    // console.log('Scene14');
    // this.$parent.chapter.$tl.seek(8)
    
  }
}
</script>























